<template>
  <div class="complain">
    <v-topBar :yellowPageColumn='yellowPageColumn' :productAndSolutionColumn='productAndSolutionColumn' :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"> </v-topBar>
    <div class="setNavBg">
      <v-header :navigationColumnInfos='navigationColumnInfos' :webConfigInfo='webConfigInfo'  :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"></v-header>
    </div>
    <v-publicBanner :bannerInfo="bannerInfo"></v-publicBanner>
    <div class="complainCon clearfix">
      <div class="complainRight pull-right">
        <div>
          <h4><span></span>投诉责任</h4>
          <div class="complainBox">
            <p>— 投诉人应遵守国家法律法规，不得损害他人合法利益</p>
            <p>— 投诉内容应当客观真实，不得捏造、歪曲事实，不得陷害他人</p>
            <p>— 建议内容烦请尽量详细描述，以便我方相关人员跟踪和改进</p>
          </div>
        </div>
        <div>
          <h4><span></span>投诉及建议提示</h4>
          <div class="complainBox">
            <p>— 我们鼓励投诉人使用自己的真实姓名进行实名举报，优先办理实名举报并及时反馈受理情况及处理结果</p>
            <p>— 我们承诺对实名举报人的个人信息及举报内容进行严格保密，让您举报无后顾之忧</p>
          </div>
        </div>
        <div>
          <h4><span></span>投诉方式</h4>
          <div class="complainBox">
            <p>— 您可以电话投诉、邮件投诉和网上投诉</p>
            <p>— 您可以在网上填写表单投诉</p>
          </div>
        </div>
        <div>
          <h4><span></span>投诉处理</h4>
          <div class="complainBox">
            <p>— 我们收到举报后1个工作日内，由专人进行回复或直接与举报人联系沟通，立案获准之日起1个月内办结，并将调查结果和举报人沟通</p>
            <p>— 经查实存在问题的职员或单位，我们会依据集团相关规定进行严肃处理</p>
          </div>
        </div>
        <div>
          <h4><span></span>投诉联系方式</h4>
          <div class="complainBox">
            <div class="contactBox">
              <h4 class="contactMan">张女士<span>（复星集团投诉）</span></h4>
              <p class="contactNumber">021-23156633</p>
              <p class="contactMailbox">fosuncgts@fosun.com</p>
            </div>
            <div class="contactBox">
              <h4 class="contactMan">宋女士<span>（复星集团廉政督察部）</span></h4>
              <p class="contactNumber">021-23156625</p>
              <p class="contactMailbox">lianzhengdc@fosun.com</p>
              <p>微信公众号：复星廉政<img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/lz_erweima.png" alt=""></p>
            </div>
            <div class="contactBox">
              <h4 class="contactMan">佘小姐<span>（复星蜂巢廉政及豫园股份）</span></h4>
              <p class="contactNumber">021-23156625</p>
              <p class="contactMailbox">lianzhengdc@fosun.com</p>
              <p>微信公众号：复星廉政<img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/lz_erweima.png" alt=""></p>
            </div>
          </div>
        </div>
      </div>
      <div class="complainLeft">
        <el-form :model="complainForm" label-width="100px"  :rules="rules" ref="ruleForm" method="post" class="form-horizontal" >
              <el-form-item prop="complaintsType"  label="投诉种类">

                  <el-select  v-model="complainForm.complaintsType" :maxlength="20"  filterable placeholder="投诉种类" >
                      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                  </el-select>

              </el-form-item>

            <el-form-item prop="complaintsUserName"  label="投诉人姓名">
              <el-input type="text"  v-model="complainForm.complaintsUserName" name="complaintsUserName" placeholder="请输入投诉人姓名"  :maxlength="20"/>
            </el-form-item>
            <el-form-item prop="complaintsUnit"  label="投诉人单位">
                <el-input type="text"  v-model="complainForm.complaintsUnit" name="complaintsUnit" placeholder="请输入投诉人单位"  :maxlength="50"/>
            </el-form-item>
            <el-form-item prop="complaintsEmail"  label="邮箱">
                <el-input type="email"  v-model="complainForm.complaintsEmail" name="complaintsEmail" placeholder="请输入邮箱" :maxlength="50" />
            </el-form-item>



            <el-form-item prop="complaintsPhone"  label="手机">
                <el-input type="text" v-model="complainForm.complaintsPhone" name="complaintsPhone" placeholder="请输入手机号码" />
            </el-form-item>
            <el-form-item prop="complaintsNature"  label="投诉性质">
                  <el-select  v-model="complainForm.complaintsNature" :maxlength="20"  filterable placeholder="投诉性质" >
                      <el-option v-for="item in natureOptions" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                  </el-select>
              </el-form-item>

            <el-form-item prop="beenComplaintsUserName"  label="被投诉人">

                <el-input type="text" v-model="complainForm.beenComplaintsUserName" name="inviteBidsUnit" placeholder="请输入被投诉人" :maxlength="20"/>

            </el-form-item>
            <el-form-item prop="inviteBidsUnit"  label="被投诉单位">
                <el-input type="text" v-model="complainForm.inviteBidsUnit" name="inviteBidsUnit" placeholder="请输入被投诉人单位" :maxlength="50"/>
            </el-form-item>

            <el-form-item prop="inviteBidsItem"  label="被投诉事项">

                <el-input type="text" v-model="complainForm.inviteBidsItem" name="inviteBidsItem" placeholder="请输入被投诉事项" :maxlength="100"/>

            </el-form-item>


            <el-form-item prop="complaintsText"  label="投诉内容">

                <el-input   type="textarea"  v-model="complainForm.complaintsText" name="inviteBidsItem" placeholder="请输入投诉内容" :maxlength="200"/>

            </el-form-item>


            <el-form-item  label="附件">

                <div class="upBtn">
                  <input type="file" id="exampleInputFile" name="upfile" @change="tirggerFile($event)" multiple>
                  <input class="btn btn-default" type="button" value="选取文件" >
                </div>
                <a href="#" class="filesList" @click="viewAttachment()" v-if="showFlag">{{complainForm.complaintsAttachmentName}}</a>

            </el-form-item>

          <div class="form-group verificationCode">
            <label class="control-label pull-left">验证码</label>
            <div class="control-con">
              <input type="text" class="form-control pull-left" placeholder="请输入验证码" @blur="checkVerifyCode()" ref="verifyCode" v-model="verifyCodeExt"/>
              <img class="pull-left" id="verifyCode" :src="verrifyCodeUrl" alt="验证码出不来,请点击" @click="changeVerifyCode()">
              <a @click="changeVerifyCode()">看不清，换一张</a>
            </div>
          </div>


            <el-form-item  label="" class="btnBox">

                <button type="button" class="btn btn-info" id="validateBtn" @click="submit()">提交</button><button type="button" class="btn btn-info" @click="reset()">重填</button>

            </el-form-item>

        </el-form>
      </div>
    </div>
    <v-footer :webConfigInfo='webConfigInfo'  :footerColumnInfos='footerColumnInfos' ></v-footer>
    <v-backToTop></v-backToTop>
  </div>
</template>
<script>
  import header from '@/components/v-header/header'
  import topBar from '@/components/topBar'
  import publicBanner from '@/components/publicBanner'
  import footer from '@/components/v-footer'
  import backToTop from '@/components/backToTop'

  export default {
    props: [],
    data () {
      var checkMobile = (rule, value, callback) => {
        var reg=/^[1][3,4,5,7,8][0-9]{9}$/;
        if (!reg.test(value)) {
          return callback(new Error('请输入11位有效手机号码'));
        }else{
          return callback();
        }
      };
      return {
        fileList2: [],
        showFlag:false,
        navigationColumnInfos: [],
        footerColumnInfos:[],
        bannerInfo: {title: '我要投诉',content: "请您填妥下表并点击提交，感谢您的监督与关注"},
        webConfigInfo: {},
        verrifyCodeUrl:"",
        verifyCode:"",
        checkVerifyFlag:false,
        hitSearchUrl:'',
        verifyCodeExt:'',
        rules: {
          complaintsUserName: [
            { required: true, message: '请输入投诉人名称', trigger: 'blur' },
            { max: 20, message: '投诉人名称最大长度20位', trigger: 'blur' }
          ],
          complaintsUnit: [
            { required: true, message: '请输入投诉人单位', trigger: 'blur' },
            { max: 50, message: '投诉人单位最大长度50位', trigger: 'blur' }
          ],
          complaintsEmail: [
             { required: true, message: '请输入邮箱地址', trigger: 'blur' },
             { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] },
            { max: 50, message: '邮箱地址最大长度50位', trigger: 'blur' }
          ],
          complaintsPhone: [
            { required: true, message: '请输入手机号码', trigger: 'blur' }
          ],
          inviteBidsUnit: [
            { required: true, message: '请输入被投诉人单位', trigger: 'blur' },
            { max: 100, message: '投诉人单位最大长度100位', trigger: 'blur' }
          ],
          complaintsType:[
            { required: true, message: '请输入投诉种类', trigger: 'blur' }
          ],
          complaintsNature:[
            { required: true, message: '请输入投诉性质', trigger: 'blur' }
          ],
          inviteBidsItem:[
            { required: true, message: '请输入投诉事项', trigger: 'blur' }
          ],
          complaintsText:[
            { required: true, message: '请输入投诉内容', trigger: 'blur' }
          ],
          beenComplaintsUserName:[
            { required: true, message: '请输入被投诉人', trigger: 'blur' }
          ]
        },
        complainForm:{
          complaintsUserName:"",
          complaintsUnit:"",
          complaintsEmail:"",
          complaintsPhone:"",
          inviteBidsUnit:"",
          complaintsType:"",
          complaintsNature:"",
          inviteBidsItem:"",
          complaintsText:"",
          upfile:{},
          complaintsAttachmentKey:"",
          complaintsAttachmentName:"",
          fileUrl:"",
          beenComplaintsUserName:""
        },
        options: [{
          value: '10',
          label: '实名投诉'
        }],
        natureOptions: [{
          value: '20',
          label: '采购管理投诉'
        }],
        hitSearchUrl:'',
        enterpriseResourceBaseUrl:'',
        yellowPageColumn:{},
        productAndSolutionColumn:{}
      }
    },
    components: {
      'v-header': header,
      'v-topBar': topBar,
      'v-publicBanner': publicBanner,
      'v-footer': footer,
      'v-backToTop': backToTop
    },
    created () {
      this.$axios.post('/onelink.mdata.main.api/mainInfo/findMainCommonInfo', {
      }).then((res) => {
        this.data = res.data;
        this.webConfigInfo = this.data.webConfigInfoDto;
        this.footerColumnInfos = this.data.footerColumnInfos;
        this.navigationColumnInfos = this.data.navigationColumnInfos;

        this.verrifyCodeUrl = this.data.verrifyCodeUrl+"?operateType=complain_&?date=" + encodeURI(encodeURI(new Date()));
        this.hitSearchUrl = this.data.hitSearchUrl;
        this.yellowPageColumn = this.data.yellowPageColumn;
        this.productAndSolutionColumn = this.data.productAndSolutionColumn;
        this.enterpriseResourceBaseUrl = this.data.enterpriseResourceBaseUrl;
      }).catch((err) => {
        console.log(err)
      })
    },
    mounted () {
    },
    methods: {
      reset(){
        this.complainForm.complaintsUserName="";
        this.complainForm.complaintsUnit="";
        this.complainForm.complaintsEmail="";
        this.complainForm.complaintsPhone="";
        this.complainForm.inviteBidsUnit="";
        this.complainForm.complaintsType="";
        this.complainForm.complaintsNature="";
        this.complainForm.inviteBidsItem="";
        this.complainForm.complaintsText="";
        this.complainForm.upfile={};
        this.complainForm.beenComplaintsUserName="";
        this.complainForm.complaintsAttachmentKey="";
        this.complainForm.complaintsAttachmentName="";
        this.complainForm.fileUrl="";
      },
      submit(){
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            if(!this.checkVerifyFlag){
              this.$message({
                message: "验证码输入错误",
                type: 'error'
              });
              return false;
            }
            this.$axios.post('/onelink.mdata.main.api/recruitInfo/addDoorComp', {
              complaintsUserName: this.complainForm.complaintsUserName,
              complaintsUnit: this.complainForm.complaintsUnit,
              complaintsEmail: this.complainForm.complaintsEmail,
              complaintsPhone: this.complainForm.complaintsPhone,
              inviteBidsUnit: this.complainForm.inviteBidsUnit,
              complaintsType: this.complainForm.complaintsType,
              complaintsNature: this.complainForm.complaintsNature,
              inviteBidsItem: this.complainForm.inviteBidsItem,
              complaintsText: this.complainForm.complaintsText,
              isDeleted:0,
              complaintsAttachmentKey:this.complainForm.complaintsAttachmentKey,
              complaintsAttachmentName:this.complainForm.complaintsAttachmentName,
              beenComplaintsUserName:this.complainForm.beenComplaintsUserName
            }).then((res) => {
              this.data = res.data;
              let operateFlag = this.data.data;
              if(operateFlag){
                this.$message({
                     message: "创建投诉成功!",
                     type: 'success'
                 });
                 this.centerDialogVisible = false;
              }else{
                this.$message({
                     message: "创建投诉失败!",
                     type: 'error'
                });
              }
            }).catch((err) => {
              console.log(err)
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      changeVerifyCode(){
        var img = document.getElementById("verifyCode");
        img.src = this.verrifyCodeUrl+"?operateType=complain_&?date=" + encodeURI(encodeURI(new Date()));
        this.verifyCodeExt = "";
      },
      tirggerFile(event) {
        let file = event.target.files[0];
        this.complainForm.upfile = event.target.files; // (利用console.log输出看结构就知道如何处理档案资料)
        let formData = new FormData();
        formData.append('upfile', file);
        let config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
        this.$axios.post('/onelink.mdata.main.api/upload/uploadSync', formData,config).then((res) => {
          this.data = res.data;
          this.complainForm.complaintsAttachmentKey = this.data.fileKey;
          this.complainForm.complaintsAttachmentName = this.data.fileName;
          this.complainForm.fileUrl = this.data.fileUrl;
          this.showFlag = true;
        }).catch((err) => {
          console.log(err)
        })
      },
      viewAttachment(){
        window.location.href = this.complainForm.fileUrl;
      },
      checkVerifyCode(){
        this.$axios.post('/onelink.mdata.main.api/kaptcha/verifyKaptcha?vrifyCode='+this.$refs.verifyCode.value+"&operateType=complain_", {
        }).then((res) => {
          this.data = res.data;
          let checkFlag = this.data.data;
          if(!checkFlag){
            this.$message({
                  message: "验证码输入错误",
                  type: 'error'
            });
            this.checkVerifyFlag = false;
          }else{
            this.checkVerifyFlag = true;
          }
        }).catch((err) => {
          console.log(err)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/complain/index.vue